import styled from "@emotion/styled";
import {
  createMainMenu,
  createBaseMenuItem,
  createDropdownContainer,
  createToggleButton,
  ArrowUp as ArrowUpIcon,
  ArrowDown as ArrowDownIcon,
} from "../dropdownPrimitive/styles";

export const ArrowUp = ArrowUpIcon;
export const ArrowDown = ArrowDownIcon;

export const DropdownContainer = createDropdownContainer();

export const SelectBoxContainer = styled.div`
  width: 100%;
  position: relative;
`;

export const ToggleButton = createToggleButton();

export const MainMenu = createMainMenu();

export const BaseMenuItem = createBaseMenuItem();
